import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Año", "año"),
    ColumnsFactory.TextColumn("Reunión", "reunion"),
    ColumnsFactory.TextColumn("Estado", "estado"),
    ColumnsFactory.TextColumn("Comentarios", "comentarios"),
    ColumnsFactory.DateColumn("Fecha Desde", "fDesde"),
    ColumnsFactory.DateColumn("Fecha Hasta", "fHasta")
  ];
};